export default __webpack_public_path__ + "static/media/doge_transperant.6b039635.png";